module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Book.88e1b22.woff2";